import React from 'react';
import '../../../App.css';
import Footer from '../../Footer';
import Cards from '../../Cards';
import HeroSection from '../../HeroSection';
import AboutCard from '../../aboutCard';

function laptopHome() {
  return (
    <>
    <main>
      <section id="home">
      <HeroSection />
      </section>
      <section id="about">
        <AboutCard/>
        </section>
      <section id="services">
      <Cards />
      </section>
      <section id="contact">
      <Footer />
      </section>
      </main>
    </>
  );
}

export default laptopHome;
